import { render } from "./OpenCloseShopApproval.vue?vue&type=template&id=5612e852&scoped=true&ts=true"
import script from "./OpenCloseShopApproval.vue?vue&type=script&lang=ts"
export * from "./OpenCloseShopApproval.vue?vue&type=script&lang=ts"

import "./OpenCloseShopApproval.vue?vue&type=style&index=0&id=5612e852&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5612e852"]])

export default __exports__